webpackJsonp([10],{

/***/ 1113:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_assets_js_dayoff_js__ = __webpack_require__(1350);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6f52c5f9_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dayoff_vue__ = __webpack_require__(1579);
function injectStyle (ssrContext) {
  __webpack_require__(1573)
}
var normalizeComponent = __webpack_require__(509)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6f52c5f9"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_assets_js_dayoff_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6f52c5f9_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dayoff_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 1236:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(510);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_axios__ = __webpack_require__(511);




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vue_axios__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1_axios___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  getDayoffYm: function getDayoffYm(URL, ym, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].axios.get(URL + 'dayoffym/' + ym, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  addDayoff: function addDayoff(URL, obj, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].axios.post(URL + 'dayoff', obj, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  editDayoff: function editDayoff(URL, cdof_id, obj, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].axios.put(URL + 'dayoff/' + cdof_id, obj, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  },
  deleteDayoff: function deleteDayoff(URL, cdof_id, header, success, error) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].axios.delete(URL + 'dayoff/' + cdof_id, header).then(function (response) {
      success(response.data);
    }, function (response) {
      error(response);
    });
  }
});

/***/ }),

/***/ 1350:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__models_dayoff__ = __webpack_require__(1236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_modal_dayoff_add_modal__ = __webpack_require__(1575);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_modal_dayoff_edit_modal__ = __webpack_require__(1577);
// var moment = require('moment')




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'dayoff',
  components: {
    addDayoffModal: __WEBPACK_IMPORTED_MODULE_1__components_modal_dayoff_add_modal__["a" /* default */],
    editDayoffModal: __WEBPACK_IMPORTED_MODULE_2__components_modal_dayoff_edit_modal__["a" /* default */]
  },
  data: function data() {
    return {
      is_load: false,
      years: [],
      months: ['January', 'February', 'March', 'April', 'May', 'June', 'July ', 'August', 'September', 'October', 'November', 'December'],
      date: new Date(),
      current_ymd: [],
      active_ym: [],
      render_m: 0,
      render_y: 0,
      calendar: [],
      modal_type: 'add',
      modal_data: {
        cdof_title: '',
        cdof_date: '',
        cdof_is_active: 1,
        cdof_type: 1
      }
    };
  },
  created: function created() {
    this.checkOAuth();
    this.current_ymd['d'] = this.date.getDate();
    this.current_ymd['m'] = this.date.getMonth();
    this.current_ymd['y'] = this.date.getFullYear();

    this.active_ym['m'] = this.date.getMonth();
    this.active_ym['y'] = this.date.getFullYear();

    this.render_m = this.date.getMonth();
    this.render_y = this.date.getFullYear();

    var min_year = parseInt(this.current_ymd['y']) - 10;
    var max_year = parseInt(this.current_ymd['y']) + 10;

    for (var i = min_year; i <= max_year; i++) {
      this.years.push(i);
    }
  },
  mounted: function mounted() {
    var _this = this;

    setTimeout(function () {
      if (sessionStorage.token) {
        _this.renderCalendar();
      } else {
        setTimeout(function () {
          _this.renderCalendar();
        }, 1000);
      }
    }, 1000);
  },

  methods: {
    next: function next() {
      this.active_ym['y'] = this.active_ym['m'] === 11 ? this.active_ym['y'] + 1 : this.active_ym['y'];
      this.active_ym['m'] = this.active_ym['m'] === 11 ? 0 : this.active_ym['m'] + 1;
      this.reAssign();
      this.renderCalendar();
    },
    previous: function previous() {
      this.active_ym['y'] = this.active_ym['m'] === 0 ? this.active_ym['y'] - 1 : this.active_ym['y'];
      this.active_ym['m'] = this.active_ym['m'] === 0 ? 11 : this.active_ym['m'] - 1;
      this.reAssign();
      this.renderCalendar();
    },
    current: function current() {
      this.active_ym['y'] = this.current_ymd['y'];
      this.active_ym['m'] = this.current_ymd['m'];
      this.reAssign();
      this.renderCalendar();
    },
    selected: function selected() {
      this.active_ym['m'] = this.render_m;
      this.active_ym['y'] = this.render_y;
      this.renderCalendar();
    },
    reAssign: function reAssign() {
      // fix rerendering
      this.render_m = this.active_ym['m'];
      this.render_y = this.active_ym['y'];
    },
    renderCalendar: function renderCalendar() {
      var _this2 = this;

      if (this.is_load === false) {
        this.is_load = true;
        var year = this.active_ym['y'];
        var month = this.active_ym['m'];
        var month_ = month + 1;
        var ym = year + '-' + (month_ < 10 ? '0' + month_ : month_);
        // get dayoff
        __WEBPACK_IMPORTED_MODULE_0__models_dayoff__["a" /* default */].getDayoffYm(this.$store.state.URLHost, ym, this.header, function (result) {
          if (result.response === true) {
            // set rendering
            var first_day = new Date(year, month).getDay();
            var day_in_month = new Date(year, month + 1, 0).getDate();
            // console.log(day_in_month)
            var day = 1;
            var temp_calendar = [];
            for (var r = 0; r < 6; r++) {
              if (day <= day_in_month) {
                temp_calendar[r] = [];
                for (var c = 0; c < 7; c++) {
                  if (r === 0 && c < first_day) {
                    temp_calendar[r][c] = {
                      day: '',
                      dayoff: null
                    };
                  } else if (day > day_in_month) {
                    temp_calendar[r][c] = {
                      day: '',
                      dayoff: null
                    };
                  } else {
                    (function () {
                      var ymd = ym + '-' + (day < 10 ? '0' + day : day);
                      var index = result.data.dayoffs.findIndex(function (dayoff) {
                        return dayoff.cdof_date === ymd;
                      });
                      if (index !== -1) {
                        temp_calendar[r][c] = {
                          day: day,
                          date: ymd,
                          dayoff: result.data.dayoffs[index]
                        };
                      } else {
                        temp_calendar[r][c] = {
                          day: day,
                          date: ymd,
                          dayoff: null
                        };
                      }
                      day++;
                    })();
                  }
                }
              }
            }
            _this2.calendar = temp_calendar;
          }
          _this2.is_load = false;
        }, function (error) {
          _this2.alert_msg('error', 'An error occurred.', error.message);
          _this2.is_load = false;
        });
      }
    },
    manageCalendar: function manageCalendar(obj) {
      if (!obj.dayoff) {
        this.modal_type = 'add';
        this.modal_data = {
          cdof_id: '',
          cdof_title: '',
          cdof_date: obj.date,
          cdof_is_active: 1,
          cdof_type: 1
        };
        this.ModalBoots('dayoff_modal').show();
      } else {
        this.modal_type = 'edit';
        this.modal_data = {
          cdof_id: obj.dayoff.cdof_id,
          cdof_title: obj.dayoff.cdof_title,
          cdof_date: obj.date,
          cdof_is_active: obj.dayoff.cdof_is_active === 'Active' ? 1 : 0,
          cdof_type: obj.dayoff.cdof_type === 'Day Off' ? 1 : 0
        };
        this.ModalBoots('dayoff_modal').show();
      }
    }
  }
});

/***/ }),

/***/ 1351:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__models_dayoff__ = __webpack_require__(1236);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['renderCalendar', 'data'],
  data: function data() {
    return {
      cdof_title: '',
      cdof_date: '',
      cdof_is_active: 1,
      cdof_type: 1
    };
  },
  mounted: function mounted() {
    this.cdof_title = this.data.cdof_title;
    this.cdof_date = this.data.cdof_date;
    this.cdof_is_active = this.data.cdof_is_active;
    this.cdof_type = this.data.cdof_type;
    $('#form_add_dayoff').removeClass('was-validated');
  },

  watch: {
    data: function data(val, old_val) {
      this.cdof_title = val.cdof_title;
      this.cdof_date = val.cdof_date;
      this.cdof_is_active = val.cdof_is_active;
      this.cdof_type = val.cdof_type;
      $('#form_add_dayoff').removeClass('was-validated');
    }
  },
  methods: {
    addDayoff: function addDayoff() {
      var _this = this;

      $('#act_btn').prop('disabled', true);
      var form_data = {
        cdof_title: this.cdof_title,
        cdof_date: this.cdof_date,
        cdof_is_active: this.cdof_is_active,
        cdof_type: this.cdof_type
      };
      __WEBPACK_IMPORTED_MODULE_0__models_dayoff__["a" /* default */].addDayoff(this.$store.state.URLHost, form_data, this.header, function (result) {
        if (result.response === true) {
          _this.alert_msg('success', 'Successful.', result.message);
        } else {
          _this.alert_msg('error', 'An error occurred.', result.message);
        }
        _this.renderCalendar();
        $('#act_btn').prop('disabled', false);
        $('#dayoff_modal').modal('hide');
      }, function (error) {
        _this.alert_msg('error', 'An error occurred.', error.message);
        _this.renderCalendar();
        $('#act_btn').prop('disabled', false);
        $('#dayoff_modal').modal('hide');
      });
    }
  }
});

/***/ }),

/***/ 1352:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__models_dayoff__ = __webpack_require__(1236);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['renderCalendar', 'data'],
  data: function data() {
    return {
      cdof_id: '',
      cdof_title: '',
      // cdof_date: '',
      cdof_is_active: 1,
      cdof_type: 1
    };
  },
  mounted: function mounted() {
    this.cdof_id = this.data.cdof_id;
    this.cdof_title = this.data.cdof_title;
    // this.cdof_date = this.data.cdof_date
    this.cdof_is_active = this.data.cdof_is_active;
    this.cdof_type = this.data.cdof_type;
    $('#form_edit_dayoff').removeClass('was-validated');
  },

  watch: {
    data: function data(val, old_val) {
      this.cdof_id = val.cdof_id;
      this.cdof_title = val.cdof_title;
      // this.cdof_date = val.cdof_date
      this.cdof_is_active = val.cdof_is_active;
      this.cdof_type = val.cdof_type;
      $('#form_edit_dayoff').removeClass('was-validated');
    }
  },
  methods: {
    editDayoff: function editDayoff() {
      var _this = this;

      $('#act_btn').prop('disabled', true);
      var form_data = {
        cdof_title: this.cdof_title,
        // cdof_date: this.cdof_date,
        cdof_is_active: this.cdof_is_active,
        cdof_type: this.cdof_type
      };
      __WEBPACK_IMPORTED_MODULE_0__models_dayoff__["a" /* default */].editDayoff(this.$store.state.URLHost, this.cdof_id, form_data, this.header, function (result) {
        if (result.response === true) {
          _this.alert_msg('success', 'Successful.', result.message);
        } else {
          _this.alert_msg('error', 'An error occurred.', result.message);
        }
        _this.renderCalendar();
        $('#act_btn').prop('disabled', false);
        $('#dayoff_modal').modal('hide');
      }, function (error) {
        _this.alert_msg('error', 'An error occurred.', error.message);
        _this.renderCalendar();
        $('#act_btn').prop('disabled', false);
        $('#dayoff_modal').modal('hide');
      });
    },
    deleteDayoff: function deleteDayoff() {
      var _this2 = this;

      $('#act_btn').prop('disabled', true);
      __WEBPACK_IMPORTED_MODULE_0__models_dayoff__["a" /* default */].deleteDayoff(this.$store.state.URLHost, this.cdof_id, this.header, function (result) {
        if (result.response === true) {
          _this2.alert_msg('success', 'Successful.', result.message);
        } else {
          _this2.alert_msg('error', 'An error occurred.', result.message);
        }
        _this2.renderCalendar();
        $('#act_btn').prop('disabled', false);
        $('#dayoff_modal').modal('hide');
      }, function (error) {
        _this2.alert_msg('error', 'An error occurred.', error.message);
        _this2.renderCalendar();
        $('#act_btn').prop('disabled', false);
        $('#dayoff_modal').modal('hide');
      });
    }
  }
});

/***/ }),

/***/ 1573:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1574);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1046)("003bbb3e", content, true, {});

/***/ }),

/***/ 1574:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1045)(true);
// imports


// module
exports.push([module.i, ".cd-table[data-v-6f52c5f9]{color:#67757c;width:100%}.cd-th[data-v-6f52c5f9]{text-align:center;padding:5px 0;font-weight:600}.cd-td[data-v-6f52c5f9]{padding:0;vertical-align:top;width:14.2%;position:relative}.cd-td[data-v-6f52c5f9]:after{content:\"\";display:block;margin-top:100%}.cd-container[data-v-6f52c5f9]{width:100%;height:100%;cursor:pointer;position:absolute}.bg-active[data-v-6f52c5f9]{background-color:#ef5350!important}.txt-active[data-v-6f52c5f9]{color:#fff!important}.cd-head-label[data-v-6f52c5f9]{text-align:right;padding:3px 6px;font-size:.9375rem}.cd-data-label[data-v-6f52c5f9]{padding:5px;text-align:center;vertical-align:middle}", "", {"version":3,"sources":["/vercel/path0/ui/src/views/Dayoff.vue"],"names":[],"mappings":"AACA,2BACE,cAAe,AACf,UAAY,CACb,AACD,wBACE,kBAAmB,AACnB,cAAiB,AACjB,eAAiB,CAClB,AACD,wBACE,UAAa,AACb,mBAAoB,AACpB,YAAa,AACb,iBAAmB,CACpB,AACD,8BACE,WAAY,AACZ,cAAe,AACf,eAAiB,CAClB,AACD,+BACE,WAAY,AACZ,YAAa,AACb,eAAgB,AAChB,iBAAmB,CACpB,AACD,4BACE,kCAAqC,CACtC,AACD,6BACE,oBAA0B,CAC3B,AACD,gCACE,iBAAkB,AAClB,gBAAiB,AACjB,kBAAqB,CACtB,AACD,gCACE,YAAiB,AACjB,kBAAmB,AACnB,qBAAuB,CACxB","file":"Dayoff.vue","sourcesContent":["\n.cd-table[data-v-6f52c5f9] {\n  color: #67757c;\n  width: 100%;\n}\n.cd-th[data-v-6f52c5f9] {\n  text-align: center;\n  padding: 5px 0px;\n  font-weight: 600;\n}\n.cd-td[data-v-6f52c5f9] {\n  padding: 0px;\n  vertical-align: top;\n  width: 14.2%;\n  position: relative;\n}\n.cd-td[data-v-6f52c5f9]:after {\n  content: '';\n  display: block;\n  margin-top: 100%;\n}\n.cd-container[data-v-6f52c5f9] {\n  width: 100%;\n  height: 100%;\n  cursor: pointer;\n  position: absolute;\n}\n.bg-active[data-v-6f52c5f9] {\n  background-color: #ef5350 !important;\n}\n.txt-active[data-v-6f52c5f9] {\n  color: #ffffff !important;\n}\n.cd-head-label[data-v-6f52c5f9] {\n  text-align: right;\n  padding: 3px 6px;\n  font-size: 0.9375rem;\n}\n.cd-data-label[data-v-6f52c5f9] {\n  padding: 5px 5px;\n  text-align: center;\n  vertical-align: middle;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1575:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_dayoff_add_modal_vue__ = __webpack_require__(1351);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3f0db49e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_dayoff_add_modal_vue__ = __webpack_require__(1576);
var normalizeComponent = __webpack_require__(509)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_dayoff_add_modal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3f0db49e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_dayoff_add_modal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1576:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-content"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('form',{staticClass:"form-horizontal needs-validation",attrs:{"novalidate":"","id":"form_add_dayoff"}},[_c('div',{staticClass:"mb-3"},[_c('label',{staticClass:"col-md-12"},[_vm._v("Title")]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.cdof_title),expression:"cdof_title"}],staticClass:"form-control form-control-fix",attrs:{"type":"text","placeholder":"title","required":""},domProps:{"value":(_vm.cdof_title)},on:{"input":function($event){if($event.target.composing){ return; }_vm.cdof_title=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"invalid-feedback"},[_vm._v("Please enter dayoff title.")])])]),_vm._v(" "),_c('div',{staticClass:"mb-3"},[_c('label',{staticClass:"col-md-12"},[_vm._v("Type")]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.cdof_type),expression:"cdof_type"}],staticClass:"form-control-line form-select form-select-fix",staticStyle:{"width":"100%"},attrs:{"placeholder":"Choose type...","required":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.cdof_type=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"1"}},[_vm._v("Day Off")]),_vm._v(" "),_c('option',{attrs:{"value":"0"}},[_vm._v("Holiday")])]),_vm._v(" "),_c('div',{staticClass:"invalid-feedback"},[_vm._v("Please select a valid dayoff type.")])])]),_vm._v(" "),_c('div',{staticClass:"mb-3"},[_c('label',{staticClass:"col-md-12"},[_vm._v("Status")]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.cdof_is_active),expression:"cdof_is_active"}],staticClass:"form-control-line form-select form-select-fix",staticStyle:{"width":"100%"},attrs:{"placeholder":"Choose status...","required":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.cdof_is_active=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"1"}},[_vm._v("Active")]),_vm._v(" "),_c('option',{attrs:{"value":"0"}},[_vm._v("Inactive")])]),_vm._v(" "),_c('div',{staticClass:"invalid-feedback"},[_vm._v("Please select a valid dayoff status.")])])]),_vm._v(" "),_vm._m(1)])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_vm._m(2),_vm._v(" "),_c('button',{staticClass:"btn btn-info btn-fix",attrs:{"type":"button","id":"act_btn"},on:{"click":_vm.addDayoff}},[_c('i',{staticClass:"fas fa-save"}),_vm._v(" Save")])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-header"},[_c('h5',{staticClass:"modal-title"},[_vm._v("Add")]),_vm._v(" "),_c('button',{staticClass:"btn-close",attrs:{"type":"button","data-bs-dismiss":"modal","aria-label":"Close"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mb-3 text-center"},[_c('span',{staticClass:"text-danger"},[_vm._v("\n          ** หากมีการตั้งค่าวันหยุด Truck Pattern ที่ตั้งค่าไว้จะถูกยกเลิกทั้งหมด **\n        ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-secondary btn-fix",attrs:{"type":"button","data-bs-dismiss":"modal","id":"cls_btn"}},[_c('i',{staticClass:"fa fa-times"}),_vm._v(" Close")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1577:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_dayoff_edit_modal_vue__ = __webpack_require__(1352);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7b598220_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_dayoff_edit_modal_vue__ = __webpack_require__(1578);
var normalizeComponent = __webpack_require__(509)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_dayoff_edit_modal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7b598220_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_dayoff_edit_modal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1578:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-content"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('form',{staticClass:"form-horizontal needs-validation",attrs:{"novalidate":"","id":"form_edit_dayoff"}},[_c('div',{staticClass:"mb-3"},[_c('label',{staticClass:"col-md-12"},[_vm._v("Title")]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.cdof_title),expression:"cdof_title"}],staticClass:"form-control form-control-fix",attrs:{"type":"text","placeholder":"title","required":""},domProps:{"value":(_vm.cdof_title)},on:{"input":function($event){if($event.target.composing){ return; }_vm.cdof_title=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"invalid-feedback"},[_vm._v("Please enter dayoff title.")])])]),_vm._v(" "),_c('div',{staticClass:"mb-3"},[_c('label',{staticClass:"col-md-12"},[_vm._v("Type")]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.cdof_type),expression:"cdof_type"}],staticClass:"form-control-line form-select form-select-fix",staticStyle:{"width":"100%"},attrs:{"placeholder":"Choose type...","required":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.cdof_type=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"1"}},[_vm._v("Day Off")]),_vm._v(" "),_c('option',{attrs:{"value":"0"}},[_vm._v("Holiday")])]),_vm._v(" "),_c('div',{staticClass:"invalid-feedback"},[_vm._v("Please select a valid dayoff type.")])])]),_vm._v(" "),_c('div',{staticClass:"mb-3"},[_c('label',{staticClass:"col-md-12"},[_vm._v("Status")]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.cdof_is_active),expression:"cdof_is_active"}],staticClass:"form-control-line form-select form-select-fix",staticStyle:{"width":"100%"},attrs:{"placeholder":"Choose status...","required":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.cdof_is_active=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"1"}},[_vm._v("Active")]),_vm._v(" "),_c('option',{attrs:{"value":"0"}},[_vm._v("Inactive")])]),_vm._v(" "),_c('div',{staticClass:"invalid-feedback"},[_vm._v("Please select a valid dayoff status.")])])])])]),_vm._v(" "),_c('div',{staticClass:"row",staticStyle:{"padding":"15px"}},[_c('div',{staticClass:"col-md-4 text-left"},[_c('button',{staticClass:"btn btn-danger btn-fix",attrs:{"type":"button","id":"act_btn"},on:{"click":_vm.deleteDayoff}},[_c('i',{staticClass:"fas fa-trash-alt"}),_vm._v(" Delete")])]),_vm._v(" "),_c('div',{staticClass:"col-md-8 text-right"},[_vm._m(1),_vm._v(" "),_c('button',{staticClass:"btn btn-info btn-fix",attrs:{"type":"button","id":"act_btn"},on:{"click":_vm.editDayoff}},[_c('i',{staticClass:"fas fa-save"}),_vm._v(" Save")])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-header"},[_c('h5',{staticClass:"modal-title"},[_vm._v("Edit")]),_vm._v(" "),_c('button',{staticClass:"btn-close",attrs:{"type":"button","data-bs-dismiss":"modal","aria-label":"Close"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-secondary btn-fix",attrs:{"type":"button","data-bs-dismiss":"modal","id":"cls_btn"}},[_c('i',{staticClass:"fa fa-times"}),_vm._v(" Close")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1579:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body",staticStyle:{"position":"relative"}},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"row mt-3 mb-2"},[_c('div',{staticClass:"col-md-2 col-sm-12 col-xs-12 mb-2"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.render_y),expression:"render_y"}],staticClass:"form-select mb-2",attrs:{"name":"active"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.render_y=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},function($event){return _vm.selected()}]}},_vm._l((_vm.years),function(year,index){return _c('option',{key:index,domProps:{"value":year}},[_vm._v(_vm._s(year))])}),0)]),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-sm-12 col-xs-12 mb-2"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.render_m),expression:"render_m"}],staticClass:"form-select mb-2",attrs:{"name":"active"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.render_m=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},function($event){return _vm.selected()}]}},_vm._l((_vm.months),function(month,index){return _c('option',{key:index,domProps:{"value":index}},[_vm._v(_vm._s(month))])}),0)]),_vm._v(" "),_c('div',{staticClass:"col-md-2 col-sm-12 col-xs-12 mb-2"},[_c('div',{staticClass:"btn-group"},[_c('button',{staticClass:"btn btn-primary btn-fix",attrs:{"type":"button","disabled":_vm.is_load},on:{"click":function($event){return _vm.previous()}}},[_c('i',{staticClass:"fas fa-arrow-left"})]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary btn-fix",attrs:{"type":"button","disabled":_vm.is_load},on:{"click":function($event){return _vm.current()}}},[_vm._v("\n              Current\n            ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary btn-fix",attrs:{"type":"button","disabled":_vm.is_load},on:{"click":function($event){return _vm.next()}}},[_c('i',{staticClass:"fas fa-arrow-right"})])])]),_vm._v(" "),_c('div',{staticClass:"col-md-6 col-sm-12 col-xs-12 mb-2 text-center"},[_c('h2',[_vm._v(_vm._s(_vm.months[_vm.render_m] + ' ' + _vm.render_y))])])]),_vm._v(" "),_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"cd-table table table-bordered table-responsive-sm",attrs:{"id":"calendar"}},[_vm._m(1),_vm._v(" "),_c('tbody',{attrs:{"id":"calendar_body"}},[_c('tr',[(_vm.is_load === true)?_c('td',{staticClass:"text-center",staticStyle:{"height":"60vh","vertical-align":"middle"},attrs:{"colspan":"7"}},[_c('i',{staticClass:"fas fa-sync-alt fa-spin fa-2x fa-fw"})]):_vm._e()]),_vm._v(" "),_vm._l((_vm.calendar),function(row,rr){return _c('tr',{key:rr},_vm._l((row),function(col,rc){return _c('td',{key:rc,staticClass:"cd-td"},[(col.day)?_c('div',{staticClass:"cd-container",class:col.dayoff ? 'bg-active' : '',on:{"click":function($event){return _vm.manageCalendar(col)}}},[_c('div',{staticClass:"cd-head-label",class:col.dayoff ? 'txt-active' : ''},[_vm._v(_vm._s(col.day))]),_vm._v(" "),(col.dayoff)?_c('div',{staticClass:"cd-data-label",class:col.dayoff ? 'txt-active' : ''},[_vm._v("\n                    "+_vm._s(col.dayoff.cdof_title !== '' ? col.dayoff.cdof_title : '-')+"\n                    "),_c('br'),_vm._v("\n                    "+_vm._s('Type: ' + col.dayoff.cdof_type)+"\n                    "),_c('br'),_vm._v("\n                    "+_vm._s('Status: ' + col.dayoff.cdof_is_active)+"\n                  ")]):_vm._e()]):_vm._e()])}),0)})],2)])])]),_vm._v(" "),_c('div',{staticClass:"modal fade",attrs:{"id":"dayoff_modal","data-backdrop":"static","data-keyboard":"false","tabindex":"-1","aria-labelledby":"dayoff_modal","aria-hidden":"true"}},[_c('div',{staticClass:"modal-dialog modal-md modal-dialog-centered modal-dialog-scrollable"},[(_vm.modal_type === 'add')?_c('addDayoffModal',{attrs:{"renderCalendar":_vm.renderCalendar,"data":_vm.modal_data}}):_vm._e(),_vm._v(" "),(_vm.modal_type === 'edit')?_c('editDayoffModal',{attrs:{"renderCalendar":_vm.renderCalendar,"data":_vm.modal_data}}):_vm._e()],1)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-lg-flex d-flex justify-content-between"},[_c('div',{staticClass:"left"},[_c('h3',{staticClass:"card-title"},[_c('span',{staticClass:"lstick d-inline-block align-middle"}),_vm._v(" Calendar")])]),_vm._v(" "),_c('div',{staticClass:"right"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',{},[_c('tr',[_c('th',{staticClass:"cd-th"},[_vm._v("Sun")]),_vm._v(" "),_c('th',{staticClass:"cd-th"},[_vm._v("Mon")]),_vm._v(" "),_c('th',{staticClass:"cd-th"},[_vm._v("Tue")]),_vm._v(" "),_c('th',{staticClass:"cd-th"},[_vm._v("Wed")]),_vm._v(" "),_c('th',{staticClass:"cd-th"},[_vm._v("Thu")]),_vm._v(" "),_c('th',{staticClass:"cd-th"},[_vm._v("Fri")]),_vm._v(" "),_c('th',{staticClass:"cd-th"},[_vm._v("Sat")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/10.6074fd14c581dfeb8e29.js